import React from 'react';
import PropTypes from 'prop-types';

const LoginFooter = ({ buttonText, ...props }) => {
    return (
        <div className="cell shrink cell-block-container tx-kiosk__footer">
          <div className="cell">
            <div className="grid-x grid-padding-x align-middle">
              <div className="cell small-12">
                <button type="button" className="button button--color--secondary button--flexible" {...props}>
                  { buttonText }
                </button>
              </div>
            </div>
          </div>
        </div>
    );
};

export default LoginFooter;

LoginFooter.propTypes = {
    buttonText: PropTypes.string,
    props: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/components/login-flow-components/LoginFooter/LoginFooter.jsx